// packages/api-client/queries/contestsEditionsStageTableEntries/index.ts
import { useQuery } from "@tanstack/react-query";
export const createContestsEditionsStageTableEntriesQueries = (requests, queryClient) => ({
    useListContestsEditionsStageTableEntries: (params, options = {}) => {
        return useQuery({
            queryKey: ["contests-editions-stage-table-entries", params],
            queryFn: async ({ queryKey }) => {
                const [_key, params] = queryKey;
                return requests.listContestsEditionStageTableEntries(params);
            },
            ...options,
        });
    },
});
//# sourceMappingURL=index.js.map